import { RPInstance } from './base';

const userInfoApi = {};
const baseUrl = '/common/mypage';

userInfoApi.getUserInfo = () => {
  return RPInstance.get(`${baseUrl}`);
};

userInfoApi.delWithdrawalInfo = () => {
  return RPInstance.delete(`${baseUrl}`);
}

userInfoApi.setUserInfo = (val) => {
  return RPInstance.post(`${baseUrl}`, val);
};

userInfoApi.modifyContact = (val) => {
  return RPInstance.put(`${baseUrl}/contact`, val);
};

userInfoApi.modifyAccount = (val) => {
  return RPInstance.put(`${baseUrl}/account`, val);
};

userInfoApi.modifyUserName = (val) => {
  return RPInstance.put(`${baseUrl}/name `, val);
};

// 사업자 처리 내역
userInfoApi.getBusinessUserInfo = (val) => {
  return RPInstance.get(`${baseUrl}/business/history`, val);
};

userInfoApi.modifyBusinessTelno = (val) => {
  return RPInstance.put(`${baseUrl}/telno`, val);
};

userInfoApi.modifyBusinessEmail = (val) => {
  return RPInstance.put(`${baseUrl}/email`, val);
};

userInfoApi.modifyBusinessAccount = (val) => {
  return RPInstance.put(`${baseUrl}/business/account`, val);
};

export default {
  ...userInfoApi,
};
